var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.ModalBase,{attrs:{"name":_vm.name,"title":"Descargar abonados"},on:{"close":() => _setup.close()}},[[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('Button',{on:{"click":function($event){return _setup.getAbonados()}}},[_vm._v("DESCARGAR")])],1)])])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }